module.exports = __webpack_public_path__ + "img/6.a67c05f9.jpg";